export { default as Footer } from './Footer'
export { default as Main } from './Main'
export { default as Header } from './Header'
